import React from 'react';
import { List, Datagrid, TextField, NumberField, DateField, FunctionField } from 'react-admin';
import { Chip } from '@material-ui/core';

// Read-only: no Edit/Create export, no rowClick, no bulk actions. There is
// nothing here for a self-serve advertiser to change - this screen exists
// so they can see WHY delivery stopped without opening a support ticket.

// Mirrors the insights route's stale-value gotcha (routes/console/advertiser_account.js):
// when ops clears monthly_spend_limit to 0, the coordinator leaves
// current_month_spend/advertiser_limit_period_start at their last values. The route
// nulls those fields out in that case, so a null here means "no limit
// configured," not "zero spend" - render that state explicitly instead of
// letting NumberField/DateField print a misleading "$0.00"/blank date.
const SpendField = ({ record, source }) => {
  if (!record || record.monthly_spend_limit <= 0) {
    return <span style={{ color: '#757575' }}>No spend limit configured</span>;
  }
  return <NumberField record={record} source={source}
    options={{ style: 'currency', currency: 'USD' }} />;
};

const PeriodStartField = ({ record }) => {
  if (!record || record.monthly_spend_limit <= 0) {
    return <span style={{ color: '#757575' }}>-</span>;
  }
  return <DateField record={record} source="advertiser_limit_period_start" label="Period started" />;
};

// Paused state must be unmistakable and say why, including when it started -
// a generic "Active"/"Paused" chip alone would not answer "why," which is the
// entire point of this screen.
const StatusField = ({ record }) => {
  if (!record) return null;
  if (record.advertiser_limit_paused) {
    const since = record.advertiser_limit_paused_at
      ? new Date(record.advertiser_limit_paused_at).toLocaleString() : 'recently';
    return (
      <Chip size="small" label={`Paused - spend limit reached (since ${since})`}
        style={{ backgroundColor: '#c62828', color: '#fff' }} />
    );
  }
  if (record.monthly_spend_limit <= 0) {
    return <Chip size="small" label="No spend limit configured" />;
  }
  return <Chip size="small" label="Active" style={{ backgroundColor: '#2e7d32', color: '#fff' }} />;
};

export const AdvertiserAccountList = (props) => (
  <List {...props} bulkActionButtons={false} pagination={false}
    title="Account & Spend Limit" actions={false}>
    <Datagrid>
      <TextField source="name" label="Advertiser" />
      <NumberField source="monthly_spend_limit" label="Monthly limit"
        options={{ style: 'currency', currency: 'USD' }} />
      <FunctionField label="Spent this period"
        render={record => <SpendField record={record} source="current_month_spend" />} />
      <FunctionField label="Remaining"
        render={record => <SpendField record={record} source="remaining" />} />
      <FunctionField label="Period started"
        render={record => <PeriodStartField record={record} />} />
      <FunctionField label="Status" render={record => <StatusField record={record} />} />
    </Datagrid>
  </List>
);
